import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectPartOfFilterVisible = createSelector(
  [(store: RootState) => store.locations.partOfFilterVisible],
  (data) => data
);
